// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"930":"9b2231a6","958":"9604b45c"}[chunkId] + ".css";
};